import React, { Component } from "react";
import { Link } from "react-router-dom";
import BannerTitle from "../layouts/about/banner/BannerTitle";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
import PartnersList from "../layouts/partners/PartnersList";

import data from "../../data/cities.json";
import { firestore } from "../../helpers/Firebase";
import { TimestampToDate } from "../../helpers/functions";

class Partners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      partnersList: data.cities.map((x) => ({ ...x, id: x.ID })),
      loading: false,
      headers: [
        {
          id: 1,
          logoweb: "/assets/img/logo-small.png",
          names: "Partneri",
        },
      ],
      banners: [
        {
          id: 1,
          links: "",
          titlelink: "",
          border: "",
          name: "Gradovi",
          heading: "EU GRADOVI U KOJIMA SMO DOSTUPNI",
        },
      ],
    };
  }

  // FirebaseRemoved
  // componentDidMount() {
  //   this.loadPartners();
  // }

  // async loadPartners() {
  //   firestore
  //     .collection("Web/Corporate/DataBase/Cities/DataBase")
  //     .orderBy("order", "asc")
  //     .get()
  //     .then((querySnapshot) => {
  //       const partnersList = [];

  //       console.log(querySnapshot);

  //       querySnapshot.forEach((doc) => {
  //         const data = doc.data();

  //         if (data.partnerStatus !== "Inactive")
  //           partnersList.push({
  //             ...data,
  //             id: doc.id,
  //           });
  //       });

  //       this.setState({ partnersList, loading: false });
  //     });
  // }

  render() {
    const { partnersList, loading } = this.state;

    return (
      <div className="header-fixed page no-sidebar header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <BannerTitle key={data.id} data={data} />
            ))}

            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content">
                      <div className="row-services">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={73}
                                data-mobile={60}
                                data-smobile={60}
                              />
                              <ul className="themesflat-filter style-1 clearfix">
                                <li className="active">
                                  <Link to="#" data-filter="*">
                                    SVE
                                  </Link>
                                </li>

                                <li>
                                  <Link to="#" data-filter=".croatia">
                                    HRVATSKA{" (20)"}
                                  </Link>
                                </li>
                                <li>
                                  <a href="#" data-filter=".belgium">
                                    BELGIUM{" (2)"}
                                  </a>
                                </li>
                                <li>
                                  <Link to="#" data-filter=".slovenia">
                                    SLOVENIA{" (0)"}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" data-filter=".sweden">
                                    SWEDEN{" (0)"}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" data-filter=".sweden">
                                    AUSTRIA{" (0)"}
                                  </Link>
                                </li>
                              </ul>
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={40}
                                data-mobile={35}
                                data-smobile={35}
                              />

                              <PartnersList partnersList={partnersList} />

                              {/*
                              <div className="button-wrap has-icon icon-left size-14 pf21 text-center">
                                <Link
                                  to="#"
                                  className="themesflat-button bg-accent pd32"
                                >
                                  <span>
                                    LOAD MORE{" "}
                                    <span className="icon">
                                      <i className="ion-load-c" />
                                    </span>
                                  </span>
                                </Link>
            </div>*/}
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={72}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Partners;
